module.exports = __webpack_public_path__ + "media/王小旌卖米的故事.801173e2.mp4";